import { Controller } from "@hotwired/stimulus"

// Decides which picture the photo dialog shows: a tile opens it on its own,
// the arrows, thumbnails and arrow keys move through the list.
export default class extends Controller {
  static outlets = ["dialog"]
  static targets = ["image", "thumb", "counter"]
  static values = { index: Number }

  open(event) {
    this.indexValue = Number(event.params.index)
    this.render()
    this.dialogOutlet.open()
  }

  previous() {
    this.indexValue = (this.indexValue - 1 + this.count) % this.count
    this.render()
  }

  next() {
    this.indexValue = (this.indexValue + 1) % this.count
    this.render()
  }

  show(event) {
    this.indexValue = Number(event.params.index)
    this.render()
  }

  keydown(event) {
    if (!this.dialogOutlet.element.open) return

    if (event.key === "ArrowLeft") this.previous()
    if (event.key === "ArrowRight") this.next()
  }

  // Called only once the viewer is in use, so the large image is not fetched
  // for a page whose viewer never opens.
  render() {
    const thumb = this.thumbTargets[this.indexValue]
    if (!thumb) return

    this.imageTarget.src = thumb.dataset.galleryLargeUrl
    this.imageTarget.alt = thumb.dataset.galleryAlt
    this.counterTarget.textContent = `${this.indexValue + 1} of ${this.count}`

    this.thumbTargets.forEach((each, index) => {
      each.classList.toggle("is-current", index === this.indexValue)
      each.setAttribute("aria-current", index === this.indexValue ? "true" : "false")
    })

    thumb.scrollIntoView({ block: "nearest", inline: "nearest" })
  }

  get count() {
    return this.thumbTargets.length
  }
}
